<template>
  <div class="content-wrapper">
    <PageHeader screenName="Agendamento" :linkItems="linkItems" />
      <b-tabs active-nav-item-class="text-custom-blue" v-model="activeTab">
        <b-tab title="Novo Agendamento">
          <CadastrarAgendamento :selectedCompanyProp="selectedCompany" />
        </b-tab>
        <b-tab title="Empresas no Mapa">
          <AgendamentoMapTab @companyToAgendamento="emitCompanyToAgendamento" />
        </b-tab>
      </b-tabs>
  </div>
</template>

<script>
import PageHeader from '@/views/components/custom/page-header/PageHeader.vue';
import { BTabs, BTab } from 'bootstrap-vue'
import CadastrarAgendamento from '../Cadastrar-agendamento.vue';
import AgendamentoMapTab from './AgendamentoMapTab.vue';

export default {
  title: 'Agendamentos',
  components: {
    PageHeader, BTabs, BTab, CadastrarAgendamento, AgendamentoMapTab
  },
  data() {
    return {
      linkItems: [
        {
          name: 'Agendamentos',
          routeName: 'agendamento-list',
        },
        {
          name: 'Cadastrar novo',
          active: true
        }
      ],
      activeTab: 0,
      selectedCompany: null

    }
  },
  methods: {
    emitCompanyToAgendamento(company) {
      this.selectedCompany = company
      this.activeTab = 0
    }
  }
}
</script>